var map = {
	"./1.svg": 81029,
	"./10.svg": 45087,
	"./11.svg": 30446,
	"./2.svg": 44806,
	"./3.svg": 7607,
	"./4.svg": 12536,
	"./5.svg": 71689,
	"./6.svg": 46106,
	"./7.svg": 51371,
	"./8.svg": 36396,
	"./9.svg": 94234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44412;